import React from "react";
import { REORDERING } from "ui/pages/TemplatePreview/constants";
import {
  EXLY_WEBPAGE_DETAILS__FETCH_KEYWORDS,
  EXLY_WEBPAGE_DETAILS__SET_REORDERING_TYPE,
  EXLY_WEBPAGE_DETAILS__REQUEST_LISTINGS,
  EXLY_WEBPAGE_DETAILS__GET_SAVED_REORDER_TYPE,
} from "ui/pages/TemplatePreview/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { is_empty } from "utils/validations";
import { WebpageCreationContext } from "ui/pages/TemplatePreview";
import ExlyImage from "common/Components/ExlyImage";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import { getCustomizationAssets } from "../../common/utils/Customizations.utils";

export const ReorderingTypes = ({ disableAllEdits }) => {
  const dispatch = useDispatch();
  const listings_data = useSelector((state) => state.webpage_detail.listings);
  const saved_reordering_type = useSelector(
    (state) => state.webpage_detail.saved_reordering_type
  );

  const { pushNotif } = React.useContext(WebpageCreationContext);

  React.useEffect(() => {
    dispatch({ type: EXLY_WEBPAGE_DETAILS__GET_SAVED_REORDER_TYPE });
    dispatch({ type: EXLY_WEBPAGE_DETAILS__REQUEST_LISTINGS });
    dispatch({ type: EXLY_WEBPAGE_DETAILS__FETCH_KEYWORDS });
  }, []);

  const handleClick = (id) => {
    if (!is_empty(listings_data)) {
      dispatch({
        type: EXLY_WEBPAGE_DETAILS__SET_REORDERING_TYPE,
        selected_reordering_type: id,
      });
    } else {
      pushNotif("Create a listing first!");
    }
  };

  return (
    <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-start md:tw-gap-5 tw-px-4 tw-pt-5 tw-pb-1 md:tw-p-0">
      <ExlyImage
        src={getCustomizationAssets("reorder.svg")}
        className="tw-w-10 tw-hidden md:tw-block tw-py-6"
      />
      <div className="tw-flex tw-flex-col md:tw-flex-1 md:tw-min-w-0 md:tw-flex-row md:tw-justify-between md:tw-py-6 tw-w-full">
        <div className="tw-flex tw-flex-col md:tw-w-[27%] tw-pr-8 md:tw-pr-0">
          <h1 className="tw-font-medium tw-text-lg">Reorder Offerings</h1>
          <p className="tw-text-sm tw-font-normal tw-text-[#272522] tw-opacity-60">
            Customize how offerings appear on your homepage
          </p>
        </div>
        <div className="tw-flex tw-w-full md:tw-w-[68%] tw-gap-8 tw-px-0 tw-pt-6 tw-pb-4 md:tw-p-6 tw-border-[1px] tw-rounded-md tw-border-[#E8E8E8] tw-border-none md:tw-border-solid tw-overflow-x-scroll md:tw-overflow-x-hidden">
        {REORDERING.types.map((item) => (
          <div className="md:tw-w-1/4" key={item.id}>
            <ExlyImage
              src={getCustomizationAssets(`${item.img}`)}
              className={`tw-m-0 tw-p-0 tw-w-[14rem] md:tw-w-full ${
                item.category_types.includes(saved_reordering_type)
                  ? "tw-border-solid tw-border-[2px] tw-mb-4 tw-border-[#493AB1] tw-rounded-xl"
                  : " tw-mb-3"
              }`}
            />

            <h1 className="tw-text-sm tw-text-[#272522]">{item.title}</h1>
            <p className="tw-text-xs tw-text-[#272522] tw-opacity-60">
              {item.description}
            </p>
            {!disableAllEdits && (
              <div
                className="tw-flex tw-items-center tw-mt-2 tw-cursor-pointer"
                onClick={() => handleClick(item.id)}
              >
                <span className="tw-text-xs tw-font-medium tw-text-[#493AB1]">
                  Setup
                </span>
                <ArrowForwardIosIcon className="tw-mt-[2px] tw-ml-1 !tw-w-3 !tw-h-3" />
              </div>
            )}
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};
